import React, { useEffect, useState, useRef} from 'react';
import { useLocation } from 'react-router-dom';

const VideoOverlay = () => {
    const location = useLocation();
    const [videoLink, setVideoLink] = useState('');
    const [videoEnded, setVideoEnded] = useState(false);
    const [videoBlob, setVideoBlob] = useState(null); // New state for storing Blob
    const [isLoading, setIsLoading] = useState(false);
    const videoRef = useRef(null); // Reference to the video element

    const id = location.pathname.substring(1);
    console.log("Received ID:", id);

    useEffect(() => {
        const fetchVideo = async () => {
            if (!id) return;

            try {
                setIsLoading(true);

                const videoUrl = `https://d1b7avqhv9t7fd.cloudfront.net/${id}/video.mp4`;

                const response = await fetch(videoUrl); // Fetch the full video
                if (!response.ok) {
                    throw new Error('Video not found in S3');
                }

                const blob = await response.blob(); // Convert to Blob
                setVideoLink(videoUrl); // Store the URL for the video
                setVideoBlob(blob); // Store the Blob for sharing
            } catch (error) {
                console.error('Error fetching video:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchVideo();
    }, [id]);


    const handleVideoEnd = () => setVideoEnded(true);

    const handleReplay = () => {
        setVideoEnded(false); // Hide the buttons
        if (videoRef.current) {
            videoRef.current.currentTime = 0; // Reset video to start
            videoRef.current.play(); // Play the video
        }
    };

    const trackEvent = (action, category, label, value) => {
        if (typeof window.gtag === 'function') {
            window.gtag('event', action, {
                event_category: category,
                event_label: label,
                value: value,
            });
        } else {
            console.error("Google Analytics gtag is not defined");
        }
    };

    const handleShare = async () => {
        try {
            if (!videoBlob) {
                throw new Error('Video blob is not ready yet.');
            }

            // Create a File object from the Blob
            const file = new File([videoBlob], '2025 Wrapped Video.mp4', { type: videoBlob.type });

            // Check if the device supports sharing with files
            if (navigator.canShare && navigator.canShare({ files: [file] })) {
                // Trigger the native sharing dialog
                await navigator.share({
                    title: '2024 Wrapped Video',
                    text: 'Check out my 2025 Wrapped video from BitLife\n\nPlay BitLife now!\n\nhttps://candywriter.net/wrapped',
                    files: [file],
                });
            } else {
                alert('Sharing files is not supported on your device or browser.');
            }
        } catch (error) {
            console.error('Error sharing the video:', error);
            alert('Sharing failed. Please try again.');
        }
    };




    return (
        <div style={{
            position: 'relative',
            width: '100%',
            height: '100%',
            backgroundColor: '#e53000', // This sets the background color layer behind everything
        }}>
            {/* Main Content Container */}
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                paddingBottom: '20px',
                width: '100vw',
                maxWidth: '650px',
                margin: '0 auto',
                height: '100vh',
                maxHeight: '950px',
                backgroundImage: 'url(/WebPage.png)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                position: 'relative',
                zIndex: 1 // Ensures this layer appears above the background color
            }}>
                {videoLink && (
                    <div style={{
                        width: '80%',
                        maxWidth: '400px',
                        maxHeight: '100vh',
                        height: 'auto',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        overflow: 'hidden',
                        paddingBottom: '30px',
                        aspectRatio: '9/16',
                        position: 'relative',
                    }}>
                        <video
                            src={videoLink}
                            autoPlay
                            playsInline
                            controls
                            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                            preload="auto"
                            onEnded={handleVideoEnd}
                            ref={videoRef}
                        />

                        {videoEnded && (
                            <>
                                {/* Transparent overlay to block video interactions */}
                                <div style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                    backgroundColor: 'rgba(0, 0, 0, 0)', // Fully transparent overlay
                                    zIndex: 10, // Places the overlay above the video but below the buttons
                                }} />

                                {/* Buttons overlay */}
                                <div style={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    gap: '10px',
                                    zIndex: 20, // Places the buttons above the overlay
                                }}>
                                    <button
                                        onClick={() => {
                                            handleShare();
                                            trackEvent('share', 'Video', 'share');
                                        }}
                                        style={{
                                            background: 'none',
                                            border: 'none',
                                            padding: 0,
                                            cursor: 'pointer',
                                            display: 'inline-block'
                                        }}>
                                        <img src="/Share%20to%20socials.png" alt="Share" style={{
                                            width: '200px',
                                            height: 'auto',
                                            cursor: 'pointer'
                                        }} />
                                    </button>

                                    <button
                                        onClick={() => {
                                            handleShare();
                                            trackEvent('download', 'Video', '2024 Wrapped Video');
                                        }}
                                        style={{
                                            background: 'none',
                                            border: 'none',
                                            padding: 0,
                                            cursor: 'pointer',
                                            display: 'inline-block'
                                        }}>
                                        <img src="/Download%20the%20video.png" alt="Download Video" style={{
                                            width: '200px',
                                            height: 'auto',
                                            cursor: 'pointer'
                                        }} />
                                    </button>

                                    <a
                                        href="#replay"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleReplay();
                                        }}
                                        style={{ textDecoration: 'none' }}
                                    >
                                        <img src="/Replay%20video.png" alt="Replay Video" style={{
                                            width: '200px',
                                            height: 'auto',
                                            cursor: 'pointer'
                                        }} />
                                    </a>

                                    <a
                                        href="https://bitlife.onelink.me/oNst/v043dsv3"
                                        onClick={(e) => {
                                            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
                                            if (/android/i.test(userAgent) || /iPad|iPhone|iPod/.test(userAgent)) {
                                                // Let the href handle it
                                                return;
                                            } else {
                                                e.preventDefault();
                                                alert("BitLife is available on iOS and Android devices. Please visit the App Store or Google Play.");
                                            }
                                        }}
                                        style={{ textDecoration: 'none' }}
                                    >
                                        <img src="/download%20App.png" alt="Download BitLife" style={{
                                            width: '200px',
                                            height: 'auto',
                                            cursor: 'pointer'
                                        }} />
                                    </a>
                                </div>
                            </>
                        )}
                    </div>
                )}

                {isLoading && (
                    <div style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        zIndex: 1000,
                    }}>
                        <div style={{
                            width: '40px',
                            height: '40px',
                            border: '4px solid rgba(0, 0, 0, 0.2)',
                            borderTop: '4px solid black',
                            borderRadius: '50%',
                            animation: 'spin 1s linear infinite',
                        }} />
                    </div>
                )}

                <style>
                    {`
        @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
        }
    `}
                </style>

                <div style={{
                    position: 'absolute',
                    bottom: '5vh',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    display: 'flex',
                    gap: '20px',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <button
                        onClick={() => window.open('https://twitter.com/BitLifeApp', '_blank')}
                        style={{
                            background: 'none',
                            border: 'none',
                            padding: 0,
                            cursor: 'pointer',
                            width: '125px',
                            height: '50px'
                        }}
                    >
                        <img src="/X_logo.png" alt="X" style={{ width: '100%', height: '100%' }} />
                    </button>

                    <button
                        onClick={() => window.open('https://www.instagram.com/bitlifeapp', '_blank')}
                        style={{
                            background: 'none',
                            border: 'none',
                            padding: 0,
                            cursor: 'pointer',
                            width: '125px',
                            height: '50px'
                        }}
                    >
                        <img src="/Instagram_simple_icon.png" alt="Instagram" style={{ width: '100%', height: '100%' }} />
                    </button>

                    <button
                        onClick={() => window.open('https://www.tiktok.com/@bitlifeapp', '_blank')}
                        style={{
                            background: 'none',
                            border: 'none',
                            padding: 0,
                            cursor: 'pointer',
                            width: '125px',
                            height: '50px'
                        }}
                    >
                        <img src="/TikTok_logo.png" alt="TikTok" style={{ width: '100%', height: '100%' }} />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default VideoOverlay;
